export default __webpack_public_path__ + "static/media/not-found.34a0bc55.svg";